export default "__VITE_ASSET__Bfp4v0nR__"